import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import "./ForgotPassword.css"
import Navbar from './Navbar';

const ForgotPassword = () => {
  const [forgotPasswordData, setForgotPasswordData] = useState({
    email: ''
  });
  const [message, setMessage] = useState('');

  // Funkce pro změnu hodnoty v inputu
  const handleForgotPasswordInputChange = (e) => {
    const {name, value} = e.target
    setForgotPasswordData((prev) => ({
        ...prev,
        [name]: value,
    }));
  };

  // Funkce pro odeslání formuláře
  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/forgot-password`, {
            email: forgotPasswordData.email
        })
        setMessage(response.data.message)
    } catch (err) {
        setMessage(err.response?.data?.message)
    }
  };

  return (<div>
     <Navbar />
<div className="forgot-password-container">
  <h2 className="forgot-password-title">Zapomenuté heslo</h2>
  <form className="forgot-password-form" onSubmit={handleForgotPasswordSubmit}>
    <input
      type="email"
      placeholder="Zadejte svůj email"
      name="email"
      value={forgotPasswordData.email}
      onChange={handleForgotPasswordInputChange}
      required
      className="forgot-password-input"
    />
    <button type="submit" className="forgot-password-button">Odeslat</button>
  </form>

  {/* Odkazy pod tlačítkem */}
  <div className="forgot-password-links">
    <Link to="/login" className="forgot-password-link">Zpět na přihlášení</Link>
  </div>

  {message && <p className="message">{message}</p>}
</div>
</div>
  );
}

export default ForgotPassword;
